import React from 'react';
import styles from './enrichment-geo.module.sass';
import { Typography, Table } from 'antd';
import { StopOutlined } from '@ant-design/icons';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import EuFlag from '../../../../assets/icons/Flag-european-union.svg';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';

function EnrichmentGeo({ newData, statusNew }) {
  const { Title } = Typography;
  let geoData = undefined;

  if (newData?.response?.ip2asn) {
    geoData = newData?.response?.ip2asn?.[0]?.ip_location;
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Name" />,
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
      className: 'ant-column-white',
    },
  ];

  function returnTableData({ loading }) {
    return [
      {
        key: 1,
        name: 'Continent',
        value: loading ? (
          <LoadingSkeleton />
        ) : geoData?.continent_name ? (
          geoData?.continent_name
        ) : (
          'unavailable'
        ),
      },
      {
        key: 2,
        name: 'Country',
        value: loading ? (
          <LoadingSkeleton />
        ) : geoData?.country_name ? (
          geoData?.country_name
        ) : (
          'unavailable'
        ),
      },
      {
        key: 3,
        name: 'Country code',
        value: loading ? (
          <LoadingSkeleton />
        ) : geoData?.country_code ? (
          geoData?.country_code
        ) : (
          'unavailable'
        ),
      },
      {
        key: 4,
        name: 'Is European Union',
        value: loading ? (
          <LoadingSkeleton />
        ) : geoData?.country_is_in_european_union ? (
          <img src={EuFlag} alt="eu flag" title="eu" />
        ) : (
          <StopOutlined />
        ),
      },
    ];
  }

  return (
    <div className={styles.enrichment_geo}>
      <Title level={4}>Geo</Title>
      <Table
        columns={columns}
        dataSource={returnTableData({ loading: statusNew === 'loading' })}
        pagination={false}
      />
    </div>
  );
}

export default EnrichmentGeo;
